import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { CoverageProcessController } from 'src/controllers/coverage-process.controller'
import { CoverageProcessParams } from 'src/domain/coverage-process'

const coverageProcessController = new CoverageProcessController()

export function useUpdateCoverageProcess() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['updateCoverageProcess'],
    mutationFn: (coverageProcessDto: CoverageProcessParams) =>
      coverageProcessController.updateCoverageProcess(farmId!, coverageProcessDto)
  })
}
